<template>
  <div class="con">
    <div class="con_title">{{ title }}</div>
    <div class="con_list">
      <div class="step-list" v-for="(item, index) in setpList" :key="index">
        <div class="step">
          <img class="img" :src="item.iconUrl" :class="item.icontype" />
          <div class="text">{{ item.text }}</div>
        </div>
        <div v-if="index < 3" class="arrow"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    setpList: Array,
  },
  data() {
    return {
      openSwitch: 0,
    }
  },
}
</script>

<style lang="less" scoped>
.con {
  height: 179px;
  background: #E61717;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .con_title {
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 50px;
    text-align: center;
    margin-bottom: 25px;
  }
  .con_list {
    display: flex;
    align-items: center;
    justify-content: center;
    .step-list {
      display: flex;
      align-items: center;
      justify-content: center;
      .step {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .img {
          width: 30px;
          height: 28px;
          margin-bottom: 10px;
        }
        .text {
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 25px;
        }
      }
    }
    .arrow {
      width: 20px;
      height: 13px;
      margin-right: 60px;
      margin-left: 60px;
      background: url('../../../../assets/images/arrow-right.png');
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
}
</style>
